export const getValueFromKey = (key, array) => array.find((item) => item.value === key)?.label;
